import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "./Featured.css";
import { Link } from "react-router-dom";
import leaf6 from "../../Images/leaf6.png";

const Featured = () => {
  return (
    <div>
      <div className="flex flex-col items-center px-[10px] pt-10 mx-auto relative">
        {/* Decorative leaf for natural food vibe */}
        <img
          className="absolute w-[120px] lg:w-[350px] right-0 lg:right-[-60px] top-[40%] fa-rotate-270 hidden sm:block"
          alt="Fresh organic leaf design for Clariss Foods"
          src={leaf6}
          loading="lazy"
        />

        {/* ✅ Food-centric SEO heading */}
        <h4 className="text-center">
          <span className="text-accent text-4xl font-bold">EMBRACE</span>{" "}
          <span className="text-secondary ms-2 text-4xl font-bold">PURE GOODNESS</span>
        </h4>

        {/* ✅ Subheading for better keyword coverage */}
        <p className="text-center text-accent font-bold text-2xl mt-4">
          A Curated Collection of Organic & Healthy Foods
        </p>

        {/* ✅ Featured food product grid */}
        <div className="flex flex-row flex-wrap mx-auto w-[96%] 2xl:w-[1200px] mt-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* Sunflower Oil 5L Tin */}
            <Link to="/product/fortified-sunflower-oil-5l-tin" className="group">
              <img
                alt="Clariss Sunflower Oil – Heart-healthy cooking essential"
                src="https://i.ibb.co/5WVQqvBC/481985065-621444030804889-7292770462544156477-n.jpg"
                className="w-[100%] cursor-pointer animated-element"
                loading="lazy"
                title="Clariss Fortified Sunflower Oil 5L Tin"
              />
              <span className="sr-only">
                Shop Clariss Fortified Sunflower Oil – ideal for healthy cooking
              </span>
            </Link>

            {/* Olive Oil Collection */}
            <Link to="/product-category/olive%20oil" className="group">
              <img
                alt="Clariss Olive Oil – Premium extra virgin olive oil for wellness"
                src="https://i.ibb.co/S7BJkvjS/480287966-605845902364702-765545447993926079-n-1.jpg"
                className="w-[100%] cursor-pointer animated-element"
                loading="lazy"
                title="Clariss Olive Oil Collection"
              />
              <span className="sr-only">
                Explore Clariss premium olive oils for salads, cooking & wellness
              </span>
            </Link>

            {/* Organic Honey */}
            <Link to="/product-category/honey" className="group">
              <img
                alt="Clariss Natural Honey – Pure, unprocessed, and nutrient-rich"
                src="https://i.ibb.co/k2jrH9Rm/481243977-616734741275818-3398779896508522781-n-1.jpg"
                className="w-[100%] cursor-pointer animated-element"
                loading="lazy"
                title="Clariss Organic Honey"
              />
              <span className="sr-only">
                Browse Clariss natural & organic honey for a healthier sweetener
              </span>
            </Link>

            {/* Sunflower Oil 5L PET Bottle */}
            <Link to="/product/fortified-sunflower-oil-5l-pet" className="group">
              <img
                alt="Clariss Sunflower Oil PET Bottle – light & healthy cooking choice"
                src="https://i.ibb.co/kVyh0h5N/482011167-620620390887253-1546525342978778707-n-1.jpg"
                className="w-[100%] cursor-pointer animated-element"
                loading="lazy"
                title="Clariss Sunflower Oil 5L PET Bottle"
              />
              <span className="sr-only">
                Discover Clariss Fortified Sunflower Oil in PET bottle – healthy & convenient
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Featured;
